import { useEffect, useState } from 'react';

import { Text } from './styles';

interface TypeWriterProps {
  children: string;
  cursor?: string;
  speed?: number;
  letterWidth?: number;
}

const TypeWriterContent = ({
  children: text = '',
  letterWidth = 22,
  speed = 140,
  cursor = '_',
}: TypeWriterProps): JSX.Element => {
  const [index, setIndex] = useState(0);
  const minTextWidth =
    text
      .split('\n')
      .reduce((longest, line) => Math.max(longest, line.length), 0) *
    letterWidth;

  useEffect(() => {
    if (index >= text.length) return undefined;

    const timeout = setTimeout(
      () => setIndex((previous) => previous + 1),
      speed
    );
    return () => clearTimeout(timeout);
  }, [text, speed, index]);

  return (
    <Text
      style={{ minWidth: minTextWidth }}
      cursor={cursor}
      onClick={() => setIndex(0)}
    >
      {text.slice(0, index)}
    </Text>
  );
};

export const TypeWriter = (props: TypeWriterProps): JSX.Element => (
  <TypeWriterContent key={props.children} {...props} />
);
